export enum CompletionStatus {
    SUCCEEDED = 'Succeeded',
    FAILED = 'Failed',
    LOADING = 'Loading',
    NONE = 'None',
}
